import { Component, Input, OnInit } from '@angular/core';
import { IChecklistListStateModel } from '../../checklist';
import { SideListOptionType } from '@fi-shared/types/side-list-option-type';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ChecklistListDataModel } from '../checklist-list-data.model';
import { ChecklistListDataService } from '@fi-app/checklist/list/checklist-list-data.service';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { ISideListOptionsItem } from '@fi-shared/fi-items-list/fi-items-list';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-checklist-list-view',
    templateUrl: './checklist-list-view.component.html',
    styleUrls: ['./checklist-list-view.component.scss'],
    standalone: false,
})
export class ChecklistListViewComponent implements OnInit {
    @Input() checklistListStateModel: IChecklistListStateModel;
    @Input() listData: ChecklistListDataModel;
    @Input() isSideListShown: boolean = true;
    @Input() tagIds: number[] = [];
    sideListOptionsTopChecklist: ISideListOptionsItem[] = [];

    constructor(
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private checklistListDataService: ChecklistListDataService,
        private tabsModuleService: TabsModuleService,
        private appTextService: AppTextService,
    ) {}

    ngOnInit() {
        if (!this.listData) this.listData = this.checklistListDataService.getInstance();
        this.checklistListStateModel.listData$.next(this.listData);

        this.initSideList();
        this.tabsModuleService.setTabsSettings({
            listData: this.listData,
        });
    }

    private initSideList(): void {
        this.sideListOptionsTopChecklist = [
            { value: SideListOptionType.SharedWithMe, text: this.appTextService.get('common.shared_with_me') },
            { value: SideListOptionType.LateCheckLists, text: this.appTextService.get('checklist.late_checklists') },
            {
                value: SideListOptionType.CurrentCheckLists,
                text: this.appTextService.get('checklist.current_checklists'),
            },
            {
                value: SideListOptionType.NonCurrentChecklists,
                text: this.appTextService.get('checklist.non_current_checklists'),
            },
        ];

        // "My checklists" is not allowed for "read" users
        if (
            this.accessToApplicationTypeService.HasAccessToApplicationType(
                ApplicationSettingsType.ChecklistLocal,
                AccessRightType.Write,
            )
        ) {
            this.sideListOptionsTopChecklist.splice(1, 0, {
                value: SideListOptionType.CreatedBy,
                text: this.appTextService.get('common.created_by_me'),
            });
        }
    }

    IsSelected(filterType) {
        return this.listData && this.listData.FilterType == filterType;
    }

    LoadChecklistsByFilterType(filterType) {
        this.listData.setFilterType(filterType); //todo use ItemsListContainerBase
        this.listData.SearchFunction();
    }

    onToggleSideMenuClick() {
        if (this.listData) {
            this.listData.ToggleSideMenu();
        }
    }
}
